<template>
    <form @submit.prevent="submitForm">
        <b-row>
            <b-col>
                <field-text label="طول"  placeholder="" v-model="form.lat"/>
                <field-text label="عرض"  placeholder=""  v-model="form.long"/>
                <field-text label="تلگرام"  placeholder=""  v-model="form.telegram"/>
                <field-text label="واتس اپ"  placeholder=""  v-model="form.whatsapp"/>
                <field-text label="فیسبوک"  placeholder=""  v-model="form.facebook"/>
                <field-text label="اینستاگرام"  placeholder=""  v-model="form.instagram"/>
                <field-text label="توییتر"  placeholder=""  v-model="form.twitter"/>  
				<field-text label="یوتیوب"  placeholder=""  v-model="form.youtube"/>
                <field-text label="آپارات"  placeholder=""  v-model="form.aparat"/>
            </b-col>
            <b-col>
                <field-markdown required v-model="form.contact"  placeholder="" label="اطلاعات تماس"/>
            </b-col>
        </b-row>

        <alert :success="success" :danger="danger"></alert>
        <button-submit title="ثبت"/>
    </form>
</template>


<script>
    import ButtonSubmit from "../../ButtonSubmit";
    import Alert from "../../Alert";

    import mixinForm from "../../../mixins/mixinForm";
    import FieldText from "../../fields/FieldText";
    import FieldTextarea from "../../fields/FieldTextarea";
    import FieldMarkdown from "../../fields/FieldMarkdown";

    export default {
        mixins: [mixinForm],
        components: {
            FieldMarkdown,
            FieldText,
            FieldTextarea,
            Alert,
            ButtonSubmit,

        },
        name: "FormContact",
        data() {
            return {
                action: "/settings",
            }
        },
    }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/forms/setting/FormContact.vue